import { render } from "./demoIndex.vue?vue&type=template&id=4b4a4b85"
import script from "./demoIndex.vue?vue&type=script&lang=js"
export * from "./demoIndex.vue?vue&type=script&lang=js"

import "./demoIndex.vue?vue&type=style&index=0&id=4b4a4b85&lang=less"

import exportComponent from "D:\\project\\Mase_Customer\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__